import { LogoPropsType } from './logoTypes';

export default function NodePackageLogo({ className, monochrome }: LogoPropsType) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M0 10H32V20.6667H16V22.4444H8.88889V20.6667H0V10ZM1.77778 18.8889H5.33333V13.5556H7.11111V18.8889H8.88889V11.7778H1.77778V18.8889ZM10.6667 11.7778V20.6667H14.2222V18.8889H17.7778V11.7778H10.6667ZM14.2222 13.5556H16V17.1111H14.2222V13.5556ZM19.5556 11.7778V18.8889H23.1111V13.5556H24.8889V18.8889H26.6667V13.5556H28.4444V18.8889H30.2222V11.7778H19.5556Z"
        fill={monochrome ? 'currentColor' : '#CB3837'}
      />
      <path d="M1.77734 18.8889H5.3329V13.5556H7.11068V18.8889H8.88845V11.7778H1.77734V18.8889Z" fill="white" />
      <path
        d="M10.666 11.7778V20.6667H14.2216V18.8889H17.7771V11.7778H10.666ZM15.9993 17.1112H14.2216V13.5556H15.9993V17.1112Z"
        fill="white"
      />
      <path
        d="M19.5547 11.7778V18.8889H23.1102V13.5556H24.888V18.8889H26.6658V13.5556H28.4436V18.8889H30.2214V11.7778H19.5547Z"
        fill="white"
      />
    </svg>
  );
}
